import { Dialog } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, CongratsTrophy } from 'assets/icons';
import DialogCard from 'shared/components/dialog/dialogCard';
import { adjustDecimals } from 'shared/util/utility';
import { ApprovedBetSlipData, ApprovedBetSlipStatus } from '../interface/coupon.interface';

interface Props {
	className?: string;
	approvedBetSlipData: ApprovedBetSlipData;
	closeApprovedBetSlipModal: () => void;
}

const AcceptedBetSlipModal: React.FC<Props> = (props) => {
	const { t } = useTranslation();
	const { approvedBetSlipData, closeApprovedBetSlipModal } = props;

	const getNewOddsChangeFromResp = () => {
		if (!approvedBetSlipData.oddsChanges) {
			return '';
		}

		const oddsChangeFromResp = approvedBetSlipData.oddsChanges.toString();
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		return oddsChangeFromResp?.split('_')[2]!.split('|').flat().toString();
	};

	return (
		<Dialog
			maxWidth={'xs'}
			fullWidth
			onClose={() => {}}
			className={`custom-dialog bg--transparent custom--box-shadow text--center`}
			aria-labelledby="customized-dialog"
			open={true}
		>
			{approvedBetSlipData.status === ApprovedBetSlipStatus.SLIP_ACCEPTED && (
				<DialogCard
					className={`success--card ${props.className || ''}`}
					icon={() => <CongratsTrophy className="modal--icon lock--icon" />}
					iconTitle={t(`approveBetSlipStatus_${approvedBetSlipData.status}`)}
					subDescription={`${t('possibleWinnings')}:`}
					title={`${approvedBetSlipData.possibleWin.toFixed(2).toString()}`}
					showAmount={true}
					cardBottomText={t('ok')}
					onActionButtonClick={(e: any) => closeApprovedBetSlipModal()}
				/>
			)}
			{(approvedBetSlipData.status === ApprovedBetSlipStatus.STAKE_CHANGED ||
				approvedBetSlipData.status === ApprovedBetSlipStatus.ODDS_CHANGED ||
				approvedBetSlipData.status === ApprovedBetSlipStatus.STAKE_AND_ODDS_CHANGED) && (
				<DialogCard
					className={`success--card ${props.className || ''}`}
					icon={() => <CongratsTrophy className="modal--icon lock--icon" />}
					iconTitle={t(`approveBetSlipStatus_${approvedBetSlipData.status}`)}
					showAmount={false}
					cardBottomText={t('ok')}
					onActionButtonClick={(e: any) => closeApprovedBetSlipModal()}
				>
					{(approvedBetSlipData.status === ApprovedBetSlipStatus.STAKE_CHANGED ||
						approvedBetSlipData.status === ApprovedBetSlipStatus.STAKE_AND_ODDS_CHANGED) && (
						<>
							<p className="mt--0 mb--5 font-size--lg line-height--25 font--semi-bold card--text-color">
								{t('approveBetStackChange_1')} <br />
								<span className="font--bold font-size--20 text--success line-height--25">
									{t('Common_currency', { val: approvedBetSlipData.stake })}
								</span>
							</p>
							<p className="mt--0 mb--5 font-size--lg line-height--25 font--semi-bold card--text-color">
								{t('approveBetStackChange_2')} <br />
								<span className="font--bold font-size--20 text--success line-height--25">
									{t('Common_currency', { val: approvedBetSlipData.newStake })}
								</span>
							</p>
						</>
					)}
					{(approvedBetSlipData.status === ApprovedBetSlipStatus.ODDS_CHANGED ||
						approvedBetSlipData.status === ApprovedBetSlipStatus.STAKE_AND_ODDS_CHANGED) && (
						<>
							<p className="mt--0 mb--5 font-size--lg line-height--25 font--semi-bold card--text-color">
								{t('approveBetOddsChange_1')} <br />
								<span className="font--bold font-size--20 text--success line-height--25">
									{adjustDecimals(getNewOddsChangeFromResp())}
								</span>
							</p>
							<p className="mt--0 mb--5 font-size--lg line-height--25 font--semi-bold card--text-color">
								{t('approveBetOddsChange_2')} <br />
								<span className="font--bold font-size--20 text--success line-height--25">
									{approvedBetSlipData.newTotalOdds?.toFixed(2)}
								</span>
							</p>
						</>
					)}
				</DialogCard>
			)}

			{approvedBetSlipData.status === ApprovedBetSlipStatus.SLIP_CANCELLED && (
				<DialogCard
					className={`error--card ${props.className || ''}`}
					icon={() => <Alert className="modal--icon lock--icon" />}
					iconTitle={t(`approveBetSlipStatus_${approvedBetSlipData.status}`)}
					showAmount={false}
					cardBottomText={t('ok')}
					onActionButtonClick={(e: any) => closeApprovedBetSlipModal()}
				/>
			)}
		</Dialog>
	);
};

export default AcceptedBetSlipModal;
